import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const getSystemPoWorkflowDashboard = async () => {
  try {
    const response = await apiClient.get('/systemInvoiceManagement/workflow/dashboard');
    return response.data?.response || response.data || {};
  } catch (error) {
    handleApiError(error);
    return { invoices: [] };
  }
};
